import {usePage} from "@inertiajs/react";
import formatMoney from "@/utils/formatMoney.js";
import {useCart} from "@/contexts/cart.jsx";
import {LucideShoppingCart, ShoppingBag} from "lucide-react";
import {Badge} from "~/components/ui/badge.jsx";

export default function Cart() {
  const { cart} = useCart()
  const {total, number} = cart;

  return (
    <div className="space-x-2 flex items-center">
      <div className="relative text-gray-600">
        {/*<LucideShoppingCart className="size-6" />*/}
        <ShoppingBag className="size-6" />
        <Badge variant="destructive"  className=" text-xs font-medium absolute size-4  -top-2 -right-2">{cart.item_count}</Badge>
      </div>
      <span>
        {formatMoney(total)}
      </span>
    </div>
  )
}